<template>
  <div>
    <b-container>
      <b-row class="justify-content-center mt-5">
        <b-col class="text-center" cols="10">
          <h2 class="text-muted d-inline">
            <font-awesome-icon icon="theater-masks" class="mr-2" />
            Clients
            <a
              v-b-modal.modal-newClient
              class="btn btn-sm btn-info ml-2 rounded rounded-pill"
            >
              <font-awesome-icon icon="plus-circle" class="mr-2" />
              Add new
            </a>
          </h2>

          <hr />
        </b-col>
      </b-row>
      <b-row class="justify-content-center">
        <b-col cols="12">
          <b-card-group deck>
            <b-card
              v-for="client in clients"
              :key="client.id"
              footer-bg-variant="grey"
              header-bg-variant="light"
              no-body
            >
              <template #header>
                <h6 class="mb-2 text-secondary">
                  Projects: {{ client.projects }}
                </h6>
                <h3>
                  <b-link
                    :to="{ name: 'Client', params: { clientId: client.id } }"
                    >{{ client.company }}</b-link
                  >
                </h3>
              </template>
              <template #footer>
                <b-link
                  :to="{ name: 'Client', params: { clientId: client.id } }"
                  class="card-link btn btn-primary"
                  ><font-awesome-icon icon="eye" class="mr-2" />View</b-link
                >
                <b-link
                  class="card-link btn btn-sm btn-danger"
                  @click="delClient(client.id)"
                  ><font-awesome-icon icon="trash" class="mr-2" />DELETE</b-link
                ></template
              >
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </b-container>
    <NewClient />
  </div>
</template>
<script>
import NewClient from "@/components/NewClient.vue";

export default {
  components: { NewClient },
  data() {
    return {
      loading: true,
      clients: [],
    };
  },
  mounted: function() {
    this.getClients();
  },
  methods: {
    getClients: function() {
      this.$store
        .dispatch("api/fetchClients")
        .then(() => {
          this.clients = this.$store.getters["api/getClients"];
        })
        .catch((err) => console.log(err));
    },
    delClient: function(client_id) {
      this.$confirm({
        message: `Si prepričan? `,
        button: {
          no: "Prekliči",
          yes: "DA",
        },

        callback: (confirm) => {
          if (confirm) {
            this.$store
              .dispatch("api/deleteClient", client_id)
              .then(() => {
                this.$router.go();
              })
              .catch((err) => console.log(err));
          }
        },
      });
    },
  },
};
</script>
